import {fCurrency} from "../../utils/formatNumber";
import {translate} from "../../locales/i18n";
import {getDataForPrintingTicket, isPovlasticaTicket} from "../../helper";

let fontSize = "0.7rem";

const style = `
  @media print{ 
    @page{
      size: portrait;  
      margin: 0px !important;
      padding: 0;
      width: 100%,
    }
    body {
      margin-bottom: 20mm; 
    }
  }
`;

export default function TicketSlip(ticket, services, preview = false, advertisementTextTicket,
                                   confirmation = false, logo,
                                   isSilentPrint = false,
                                   printerSize,
                                   maxDaysOfReturn,
                                   linkedStationNames,
                                   actionOBJ,
                                   seatSelectionEnabled,
                                   isSelfSale,
                                   advertisementExtras) {
    console.debug("TicketSlip: ", {
        ticket, services, preview, advertisementTextTicket, confirmation, logo, isSilentPrint, printerSize,actionOBJ
    });

    const {
        ticketId,
        departureStationName,
        arrivalStationName,
        ticketType,
        journeyDate,
        departureTime,
        price,
        cashier,
        salesTime,
        platformNumber,
        seat,
        passengerDocumentNumber,
        passengerDetails,
        outboundTicketId,
        issuedBy,
    } = getDataForPrintingTicket(ticket, { seatSelectionEnabled, isSelfSale })
    const isPovlastica = isPovlasticaTicket(ticket);
    let width = 360;
    fontSize = isSilentPrint ? "19px" : fontSize;
    if (printerSize) {
        if (printerSize == "80") {
            width = 560;
            fontSize = "29px"
        }
    }

    let total = ticket.price
    if (services) {
        total = total + services.reduce((acc, {unitPrice}) => {
            return acc + unitPrice
        }, 0)
    }

    return (
        <html lang="sr">
        <head>
            <meta charSet="UTF-8"/>
            <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8"/>
            <style type="text/css">{style}</style>
            <title>Ticket {ticketId}</title>
        </head>
        <body
            id="forPrint"
            style={{
                fontFamily: "Calibri",
                margin: 0,
                width: "100%",
                maxWidth: isSilentPrint ? "100%" : "80mm",
                justifyContent: "center",
                display: "inline-block",
                height: "auto",
                wordBreak: "break-word",
                fontSize: fontSize
            }}>
        <table style={{
            width: preview ? "300px" : (isSilentPrint ? width : "auto"),
            margin: 0
        }}>
            <tbody style={{marginBottom: "20px"}}>
            {logo ?
                <tr>
                    <td style={{textAlign: "center"}} colSpan={4}>
                        <img alt="logo" src={logo} width={isSilentPrint ? width - 100 : "50%"}
                             height="auto"/>
                    </td>
                </tr> : <></>
            }
            <tr>
                <td style={{textAlign: "center", fontSize: fontSize}} colSpan={4}>
                    {issuedBy}
                </td>
            </tr>
            <tr>
                <td style={{textAlign: "center", fontSize: fontSize}} colSpan={4}>
                    AUTOBUSKA STANICA
                </td>
            </tr>
            <tr style={{justifyContent: "space-between"}}>
                <td style={{fontSize: fontSize}} colSpan={2}>
                    {confirmation ? "ID:" : "Broj karte:"}
                </td>
                <td style={{fontSize: fontSize, fontWeight: 700, textAlign: "right"}} colSpan={2}>
                    {ticketId}
                </td>
            </tr>
            <tr style={{justifyContent: "space-between"}}>
                <td style={{fontSize: fontSize}} colSpan={2}>
                    Operater:
                </td>
                <td style={{fontSize: fontSize, fontWeight: 700, textAlign: "right"}} colSpan={2}>
                    {cashier}
                </td>
            </tr>
            <tr style={{justifyContent: "space-between"}}>
                <td style={{fontSize: fontSize}} colSpan={2}>
                    Izdato:
                </td>
                <td style={{fontSize: fontSize, fontWeight: 700, textAlign: "right", whiteSpace: "nowrap"}} colSpan={2}>
                    {salesTime}
                </td>
            </tr>
            <tr style={{justifyContent: "space-between"}}>
                <td style={{textAlign: "center", fontWeight: 700, fontSize: fontSize}} colSpan={4}>
                    {confirmation ? "POTVRDA CENE KARTE" :
                        advertisementTextTicket === translate("testTicketText") ? "TEST KARTA" :
                            `AUTOBUSKA KARTA - ${ticket.isReturnTicket ? "POVRATNA" : "JEDAN SMER"}`}
                </td>
            </tr>
            <tr style={{justifyContent: "space-between"}}>
                <td style={{fontSize: fontSize, fontWeight: "bold"}} colSpan={2}>
                    {departureStationName}
                </td>
                <td style={{fontSize: fontSize, textAlign: "right", fontWeight: "bold"}} colSpan={2}>
                    {arrivalStationName}
                </td>
            </tr>
            {linkedStationNames && linkedStationNames?.length > 0 && linkedStationNames?.map(stationName => (
                <tr style={{justifyContent: "space-between"}}>
                    <td style={{fontSize: fontSize, fontWeight: "bold"}} colSpan={2}>
                        Prelazna stanica
                    </td>
                    <td style={{fontSize: fontSize, textAlign: "right", fontWeight: "bold"}} colSpan={2}>
                        {stationName}
                    </td>
                </tr>
            ))}
            <tr style={{justifyContent: "space-between"}}>
                <td style={{fontSize: fontSize}} colSpan={2}>
                    Prevoznik
                </td>
                <td style={{fontSize: fontSize, fontWeight: 700, textAlign: "right"}} colSpan={2}>
                    {ticket.isReturnTicket ? (ticket?.outboundTicket?.trip?.line?.operator?.name || "/") : ticket?.trip?.line?.operator?.name || ticket?.operator?.name || "//"}
                </td>
            </tr>
            <tr style={{justifyContent: "space-between"}}>
                <td style={{fontSize: fontSize, justifyContent: "space-between"}} colSpan={2}>
                    Vrsta karte:
                </td>
                <td style={{fontSize: fontSize, fontWeight: 700, textAlign: "right"}} colSpan={2}>
                    {ticketType}
                </td>
            </tr>
            <tr style={{justifyContent: "space-between"}}>
                <td style={{fontSize: fontSize}} colSpan={2}>
                    Datum putovanja:
                </td>
                <td style={{fontSize: fontSize, fontWeight: 700, textAlign: "right"}} colSpan={2}>
                    {journeyDate}
                </td>
            </tr>
            <tr style={{justifyContent: "space-between"}}>
                <td style={{fontSize: fontSize}} colSpan={2}>
                    Vreme:
                </td>
                <td style={{fontSize: fontSize, fontWeight: 700, textAlign: "right"}} colSpan={2}>
                    {departureTime}
                </td>
            </tr>
            <tr style={{justifyContent: "space-between"}}>
                <td style={{fontSize: fontSize}} colSpan={2}>
                    Peron/bis:
                </td>
                <td style={{fontSize: fontSize, fontWeight: 700, textAlign: "right"}} colSpan={2}>
                    {!ticket.isReturnTicket ? platformNumber : "/"}
                </td>
            </tr>
            <tr style={{justifyContent: "space-between"}}>
                <td style={{fontSize: fontSize}} colSpan={2}>
                    Sedište:
                </td>
                <td style={{fontSize: fontSize, fontWeight: 700, textAlign: "right"}} colSpan={2}>
                    {ticket.isReturnTicket ? (ticket?.seatReserved !== null ? ticket?.seatReserved : null) : seat}
                </td>
            </tr>
            <tr style={{justifyContent: "space-between"}}>
                <td style={{fontSize: fontSize}} colSpan={2}>
                    Cena:
                </td>
                <td style={{fontSize: fontSize, fontWeight: 700, textAlign: "right"}} colSpan={2}>
                    {price}
                </td>
            </tr>
            {!ticket.isReturnTicket && services?.length > 0 && services?.map((item, serviceIndex) => (
                <tr key={`service-${serviceIndex}`} style={{justifyContent: "space-between"}}>
                    <td style={{fontSize: fontSize}} colSpan={2}>
                        {item.name}
                    </td>
                    <td style={{fontSize: fontSize, fontWeight: 700, textAlign: "right"}} colSpan={2}>
                        {fCurrency(`${item.unitPrice}`)}
                    </td>
                </tr>
            ))}
            {Array.isArray(actionOBJ) && actionOBJ
                .filter(obj =>
                    obj.passengerUid.includes(ticket.passenger.passengerUid) &&
                    obj.isReturnTicket === ticket.isReturnTicket
                )
                .map((obj, index) => (
                    <tr key={`action-${index}`} style={{ justifyContent: "space-between" }}>
                        <td style={{ fontSize: fontSize }} colSpan={2}>
                            {obj.name}
                        </td>
                        <td style={{ fontSize: fontSize, fontWeight: 700, textAlign: "right" }} colSpan={2}>
                            {fCurrency(`${obj.unitPrice}`)}
                        </td>
                    </tr>
                ))}

            {(() => {
                const passengerUid = ticket?.passenger?.passengerUid;

                const relevantActions = Array.isArray(actionOBJ) && passengerUid
                    ? actionOBJ.filter(obj =>
                        obj.passengerUid?.includes(passengerUid) &&
                        obj.isReturnTicket === ticket.isReturnTicket
                    )
                    : [];

                const actionSum = relevantActions.reduce((acc, curr) => acc + (curr.unitPrice || 0), 0);
                const totalWithAction = (ticket.isReturnTicket ? ticket.price : total) + actionSum;

                return (
                    <tr style={{ justifyContent: "space-between" }}>
                        <td style={{ fontSize: fontSize }} colSpan={2}>
                            Ukupno:
                        </td>
                        <td style={{ fontSize: fontSize, fontWeight: 700, textAlign: "right" }} colSpan={2}>
                            {fCurrency(`${totalWithAction}`)}
                        </td>
                    </tr>
                );
            })()}


            {!isPovlastica && passengerDetails?.trim()?.length > 0 &&
                <tr style={{justifyContent: "space-between"}}>
                    <td style={{fontSize: fontSize}} colSpan={2}>
                        Putnik:
                    </td>
                    <td style={{fontSize: fontSize, fontWeight: 700, textAlign: "right"}} colSpan={2}>
                        {passengerDetails}
                    </td>
                </tr>
            }
            {isPovlastica && passengerDocumentNumber?.length > 0 &&
                <tr style={{justifyContent: "space-between"}}>
                    <td style={{fontSize: fontSize}} colSpan={2}>
                        Broj povlastice
                    </td>
                    <td style={{fontSize: fontSize, fontWeight: 700, textAlign: "right"}} colSpan={2}>
                        {passengerDocumentNumber}
                    </td>
                </tr>
            }
            <tr>
                <td style={{textAlign: "center", fontSize: fontSize, fontStyle: "italic"}} colSpan={4}>
                    Srećan put
                </td>
            </tr>
            {(confirmation) ?
                <></>
                :
                <tr>
                    <td style={{textAlign: "center"}} colSpan={4}>
                        <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                            {ticket.parsedQR && <img
                                style={{
                                    minWidth: isSilentPrint ? 360 : "40mm",
                                    minHeight: isSilentPrint ? 360 : "40mm",
                                    maxWidth: isSilentPrint ? 360 : "50mm",
                                    maxHeight: isSilentPrint ? 360 : "50mm"
                                }}
                                width={isSilentPrint ? 360 : "100%"}
                                height={isSilentPrint ? 360 : "100%"}
                                alt="qr code"
                                src={ticket.parsedQR}/>
                            }
                        </div>
                    </td>
                </tr>
            }
            {(advertisementExtras?.title || advertisementExtras?.webQrDataUrl) &&
                <tr>
                    <td style={{textAlign: "center", fontSize: fontSize, letterSpacing: "-1px"}} colSpan={4}>
                        ==============================
                    </td>
                </tr>
            }
            {advertisementExtras?.title &&
                <tr>
                    <td style={{
                        textAlign: "center",
                        fontSize: isSilentPrint ? "26px" : "1.15rem",
                        fontWeight: 700,
                        paddingTop: "4px",
                        paddingBottom: "2px"
                    }} colSpan={4}>
                        {advertisementExtras.title}
                    </td>
                </tr>
            }
            <tr>
                <td style={{textAlign: "center", fontSize: fontSize, fontStyle: "italic",
                    paddingLeft: "8px", paddingRight: "8px"}} colSpan={4}>
                    {advertisementTextTicket}
                </td>
            </tr>
            {advertisementExtras?.webQrDataUrl &&
                <tr>
                    <td align="center" style={{textAlign: "center"}} colSpan={4}>
                        <img
                            style={{
                                minWidth: isSilentPrint ? 350 : "40mm",
                                minHeight: isSilentPrint ? 350 : "40mm",
                                maxWidth: isSilentPrint ? 350 : "48mm",
                                maxHeight: isSilentPrint ? 350 : "48mm"
                            }}
                            alt="web qr code"
                            src={advertisementExtras.webQrDataUrl}/>
                        <div style={{fontSize: fontSize, textAlign: "center"}}>
                            {advertisementExtras.webAddress}
                        </div>
                    </td>
                </tr>
            }
            {ticket.isReturnTicket ?
                <>
                    <tr style={{justifyContent: "space-between"}}>
                        <td style={{fontSize: fontSize}} colSpan={2}>
                            Broj dana važenja povratne karte:
                        </td>
                        <td style={{fontSize: fontSize, fontWeight: 700, textAlign: "right"}} colSpan={2}>
                            {journeyDate || maxDaysOfReturn || "/"}
                        </td>
                    </tr>
                    <tr>
                        <td style={{
                            textAlign: "center",
                            fontSize: isSilentPrint ? "26px" : "1rem",
                            fontWeight: 700,
                            textTransform: "uppercase",
                            paddingTop: "8px",
                            paddingBottom: "4px",
                            letterSpacing: "0.5px"
                        }} colSpan={4}>
                            POVRATNA KARTA BROJ: {ticketId}
                        </td>
                    </tr>
                </> : <></>}
            {outboundTicketId ?
                <tr>
                    <td style={{
                        textAlign: "center",
                        fontSize: isSilentPrint ? "26px" : "1rem",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        paddingBottom: "8px",
                        letterSpacing: "0.5px"
                    }} colSpan={4}>
                        VAŽI UZ KARTU BROJ: {outboundTicketId}
                    </td>
                </tr> : <></>
            }
            </tbody>
        </table>
        </body>
        </html>
    );
};
